import { render, staticRenderFns } from "./yuceXiangqing.vue?vue&type=template&id=2c8b6512&scoped=true"
import script from "./yuceXiangqing.vue?vue&type=script&lang=js"
export * from "./yuceXiangqing.vue?vue&type=script&lang=js"
import style0 from "./yuceXiangqing.vue?vue&type=style&index=0&id=2c8b6512&prod&scoped=true&lang=css"
import style1 from "./yuceXiangqing.vue?vue&type=style&index=1&id=2c8b6512&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8b6512",
  null
  
)

export default component.exports